module.exports = __webpack_public_path__ + "777d97a41277c0136325f959e9bbb833.png";